import { Flex, FlexAlignCenter } from 'components/primitives/flex';
import { getMinWidthQuery, mediaMSmMax } from 'helpers/breakpoints';
import { breakpoints } from 'components/search/v2/styleConstants';
import styled from 'styled-components';

export const RedirectBanner = () => (
  <GreenBanner data-testid="redirect-banner">
    <Flex gap="15px">
      <WarningIcon />
      <span>Unfortunately this boat is no longer available, explore other boats near you.</span>
    </Flex>
  </GreenBanner>
);

const GreenBanner = styled(FlexAlignCenter)`
  grid-area: redirect-banner;
  padding: 0 22px;
  font-size: 14px;
  font-weight: 500;
  z-index: 2000;
  background: #72d4ba;
  width: 100%;
  ${getMinWidthQuery(breakpoints.MAP_CAN_SHOW)} {
    padding: 0 44px;
  }
  ${mediaMSmMax} {
    position: fixed;
    height: 55px;
    padding: 10px 22px;

    svg {
      height: 22px;
      scale: 1.4;
    }
  }
`;

const WarningIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.698 12.0866L10.6614 1.23603C10.2266 0.464543 9.41657 0 8.51279 0C7.60048 0 6.79901 0.464543 6.36417 1.23603L0.302004 12.0783C-0.115783 12.8249 -0.09873 13.7125 0.344635 14.4425C0.788001 15.1726 1.58094 15.6122 2.45915 15.6122H14.5494C15.4191 15.6122 16.212 15.1726 16.6554 14.4425C17.0987 13.7208 17.1158 12.8415 16.698 12.0866ZM15.5555 13.8121C15.3423 14.1605 14.9672 14.3679 14.5494 14.3679H2.45062C2.03283 14.3679 1.65768 14.1605 1.436 13.8121C1.21431 13.4637 1.21431 13.0406 1.41042 12.6839L7.47259 1.84159C7.68574 1.46829 8.06942 1.25264 8.50426 1.25264C8.9391 1.25264 9.32278 1.47658 9.53594 1.84159L15.5725 12.6922C15.7772 13.0406 15.7686 13.4637 15.5555 13.8121ZM7.85627 7.91394V4.86949C7.85627 4.52937 8.14616 4.24732 8.49574 4.24732C8.84531 4.24732 9.13521 4.52937 9.13521 4.86949V7.91394C9.13521 8.25406 8.84531 8.53611 8.49574 8.53611C8.14616 8.53611 7.85627 8.25406 7.85627 7.91394ZM9.70646 11.4645C9.70646 12.1115 9.16078 12.6424 8.49574 12.6424C7.83069 12.6424 7.28501 12.1115 7.28501 11.4645C7.28501 10.8174 7.83069 10.2865 8.49574 10.2865C9.16078 10.2865 9.70646 10.8091 9.70646 11.4645Z"
      fill="#17233C"
    />
  </svg>
);
